import moment from "moment";
import React, { useState } from "react";
import FilterToolbar from "../inputs/FilterToolbar";
import { Badge, Button, Pagination, Table } from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, CATEGORIES } from "../../config/apiConfig";
import Drawer from "../Drawer";
import { formatToReal } from "../../utils/utils";
import { FaDollarSign, FaEdit, FaRegEdit } from "react-icons/fa";
import QueryEditForm from "../forms/QueryEditForm";
import { IoMdSearch } from "react-icons/io";
import TableLoading from "../TableLoading";
import { Tooltip } from "react-tooltip";
import CreateQueryForm from "../forms/CreateQueryForm";
import EditQueryCustomForm from "../forms/EditQueryCustomForm";
import { MdCategory } from "react-icons/md";
import EmptyTable from "./EmptyTable";
import { RiListSettingsFill } from "react-icons/ri";
import { ModalRedudancy } from "../modals/ModalRedudancy";

const AdminRedudancyTable = ({ isActive }) => {
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const onPageChange = (page) => setCurrentPage(page);
  const [isVisibleFilter, setIsVisibleFilter] = useState(false);
  const [filterCategory, setFilterCategory] = useState("");
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [isDrawerEditQuery, setIsDrawerEditQuery] = useState(false);
  const [isDrawerEditQueryCustom, setIsDrawerEditQueryCustom] = useState(false);
  const [isDrawerCreateQuery, setIsDrawerCreateQuery] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const itemsPerPage = 20;
  const [isDragModalOpen, setIsDragModalOpen] = useState(false);
  const [dragItems, setDragItems] = useState([]);

  const {
    isLoading: isLoadingListQueries,
    error: errorListQueries,
    data: listQueries,
  } = useQuery(
    ["listQueries", currentPage, nameParam, filterCategory],
    async () => {
      try {
        const { data } = await axios.get(
          `${ADMIN.GET_QUERIES}?page=${currentPage}&searchName=${nameParam}&categoryId=${filterCategory}&itemsPerPage=${itemsPerPage}&isModular=1`
        );
        setTotalPages(data.data.totalPages || 1);
        setTotalCount(data.data.totalCount || 0);
        return data.data.data;
      } catch (error) {
        console.error("Erro ao buscar dados:", error.message);
        throw new Error("Erro ao buscar dados.");
      }
    },
    { enabled: isActive }
  );

  const {
    isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(
    ["categories"],
    async () => {
      const { data } = await axios.get(`${CATEGORIES.GET_ALL}?isModular=1`);

      return data.data.data;
    },
    { enabled: isActive }
  );

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleEditQuery = (query) => {
    setSelectedQuery(query);
    if (query?.queryCustomizedId) {
      setIsDrawerEditQueryCustom((prevState) => !prevState);
    } else {
      setIsDrawerEditQuery((prevState) => !prevState);
    }
  };

  return (
    <>
      <div className="flex flex-col md:flex-row justify-between mb-3 mt-2 items-end md:items-center gap-2">
        <FilterToolbar
          isVisible={isVisibleFilter}
          setIsVisible={setIsVisibleFilter}
        >
          <div className="flex gap-2">
            <div className="flex gap-2 flex-col md:flex-row w-full">
              <div className="flex items-center gap-2 w-full bg-gray-100 rounded-md pl-2 pr-0 py-1">
                <select
                  id="underline_select"
                  className="mt-1 block py-1 px-0 w-full md:w-40 text-sm text-gray-600 bg-transparent border-0 border-gray-300 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                  value={filterCategory}
                  onChange={({ target }) => setFilterCategory(target.value)}
                >
                  <option selected value="">
                    Todas categorias
                  </option>
                  <option value="1">Crédito</option>
                  <option value="2">Cadastral</option>
                  <option value="3">Veicular</option>
                </select>
              </div>
            </div>
          </div>
        </FilterToolbar>
      </div>
      <form
        className="flex gap-1 mt-5 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
        onSubmit={handleSearchName}
      >
        <input
          type="text"
          placeholder="Busque por nome do insumo..."
          className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
          onChange={(e) => setSearchName(e.target.value)}
          value={searchName}
        />
        <Button
          size="sm"
          className="flex items-center bg-secondary w-20"
          type="submit"
        >
          <IoMdSearch />
        </Button>
      </form>
      {listQueries?.length > 0 ? (
        <>
          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>
          <div className="overflow-x-auto shadow-md rounded-lg mt-0 md:mt-5">
            <Table striped>
              {listQueries?.length > 0 && (
                <Table.Head>
                  <Table.HeadCell className="text-center bg-gray-300">
                    ID
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-gray-300">
                    Nome do insumo
                  </Table.HeadCell>
                  <Table.HeadCell className="text-center bg-gray-300">
                    Categoria
                  </Table.HeadCell>
                  <Table.HeadCell className="text-center bg-gray-300">
                    Ações
                  </Table.HeadCell>
                </Table.Head>
              )}

              <Table.Body className="divide-y">
                {!isLoadingListQueries ? (
                  <>
                    {listQueries?.length > 0 && (
                      <>
                        {listQueries.map((query, index) => (
                          <Table.Row
                            key={index}
                            className="bg-white dark:border-gray-700 dark:bg-gray-800"
                          >
                            <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                              #{query.id}
                            </Table.Cell>
                            <Table.Cell className="font-medium text-gray-900 dark:text-white py-2">
                              {query.name}
                            </Table.Cell>{" "}
                            <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                              {query?.Category?.name}
                            </Table.Cell>
                            <Table.Cell className="text-center py-2">
                              <div className="flex items-center justify-center">
                                <Tooltip
                                  id="tooltip-edit-redudancy"
                                  content="Gerenciar Redundância"
                                />
                                <RiListSettingsFill
                                  data-tooltip-id="tooltip-edit-redudancy"
                                  fontSize="20"
                                  className=" cursor-pointer"
                                  onClick={() => {
                                    setSelectedQuery(query);
                                    setIsDragModalOpen(true);
                                  }}
                                />
                              </div>
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </>
                    )}
                  </>
                ) : (
                  <TableLoading cols={4} />
                )}
              </Table.Body>
            </Table>
          </div>
        </>
      ) : (
        <EmptyTable icon="search_off">
          Nenhuma consulta cadastrada! <br /> Clique em "Criar Nova Consulta"
          para iniciar sua experiência.
        </EmptyTable>
      )}

      {totalCount > 0 && (
        <div className="mt-3 text-center text-sm text-gray-600">
          Exibindo {(currentPage - 1) * itemsPerPage + 1}–
          {Math.min(currentPage * itemsPerPage, totalCount)} de {totalCount}{" "}
          registros
        </div>
      )}

      {totalPages > 1 && (
        <div className="flex overflow-x-auto justify-center mt-3">
          <Pagination
            layout="pagination"
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            previousLabel=""
            nextLabel=""
            showIcons
          />
        </div>
      )}
      <Drawer
        title={`Editar consulta`}
        onClose={setIsDrawerEditQuery}
        isOpen={isDrawerEditQuery}
        className={"w-full md:w-4/6 lg:w-2/6"}
      >
        <QueryEditForm
          query={selectedQuery}
          categories={categories}
          onClose={setIsDrawerEditQuery}
          fetchQueries={() => {
            queryClient.invalidateQueries(["listQueries", currentPage]);
          }}
        />
      </Drawer>

      <Drawer
        title={`Editar consulta`}
        onClose={setIsDrawerEditQueryCustom}
        isOpen={isDrawerEditQueryCustom}
        className={"w-full md:w-5/6 lg:w-4/6 xl:w-3/6"}
      >
        <EditQueryCustomForm
          categories={categories}
          onClose={setIsDrawerEditQueryCustom}
          fetchQueries={() => {
            queryClient.invalidateQueries(["listQueries", currentPage]);
          }}
          query={selectedQuery}
          isOpen={isDrawerEditQueryCustom}
        />
      </Drawer>

      <Drawer
        title={`Criar nova consulta`}
        onClose={setIsDrawerCreateQuery}
        isOpen={isDrawerCreateQuery}
        className={"w-full md:w-5/6 lg:w-4/6 xl:w-3/6"}
      >
        <CreateQueryForm
          categories={categories}
          onClose={setIsDrawerCreateQuery}
          fetchQueries={() => {
            queryClient.invalidateQueries(["listQueries", currentPage]);
          }}
          isOpen={isDrawerCreateQuery}
        />
      </Drawer>
      <ModalRedudancy
        isOpen={isDragModalOpen}
        onClose={() => setIsDragModalOpen(false)}
        title={`Editar Redundância - ${selectedQuery?.name}`}
        queryId={selectedQuery?.id}
      />
    </>
  );
};

export default AdminRedudancyTable;
